import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Header1 } from 'components/header'
import banner from '../../assets/images/bannerPlayer.png'
import { Row, Col, Card, CardBody, CardTitle, CardText, Badge, Button, InputGroup, Input } from 'reactstrap'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { getAnounceAgents, searchAnnoncesAgents, getAnounce, getProfile, searchAnnonces, getEvent, getNotification } from 'store/auth/profile/profileSlice'
import { format } from 'date-fns'
import { fr } from 'date-fns/locale'
import Header from 'components/VerticalLayout/Header'
import { ReloadOutlined } from '@ant-design/icons'
import ApplicationModal from './Formaccueille'
import AnnouncesList from './AnnouncesList'
import TabsComponent from 'components/CommonForBoth/TabsComponent'
import { getAgents } from 'store/auth/agent/agentSlice'
import AgentsList from './AgentsList'
import SubscriptionDetails from './SubscriptionDetails'
import { PaginatedList } from './PaginatedList'
import dayjs from 'dayjs'
import { fetchProfileStatus } from 'store/auth/profile/profileStatusSlice'
import ModalInfo from 'components/CommonForBoth/ModalInfo'

const Accueille = () => {
  const dispatch = useDispatch()
  const announces = useSelector((state) => state.Profile.announces.announcements)
  const announcesAgents = useSelector((state) => state.Profile.announcesAgents.announcements)
  const events = useSelector((state) => state.Profile.event.events)
  const agents = useSelector((state) => state.Agents.agents.agents)
  const { isProfileComplete } = useSelector((state) => state.ProfileStatus)
  // if (!isProfileComplete) {
  //   console.log(isProfileComplete);

  //   <ModalInfo
  //     trigger={true}
  //     title="Info"
  //     message="Ceci est une simple notification."
  //     showCancel={false}
  //   />
  // }
  const [isOpen, setIsOpen] = useState(false)
  const [anouncmentId, setAnouncmentId] = useState('')

  const [searchValue, setSearchValue] = useState({
    title: '',
    clubName: ''
  })
  const [searchValueAgents, setSearchValueAgents] = useState({
    title: '',
    agentName: ''
  })
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(getAnounce())
    dispatch(getAnounceAgents())
    dispatch(getEvent())
    dispatch(getAgents())
    dispatch(fetchProfileStatus())
  }, [dispatch])
  // Fonction pour formater la date
  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), 'dd MMMM yyyy', { locale: fr })
    } catch (error) {
      return 'Date non disponible'
    }
  }

  // Fonction pour diriger vers la page de détails de l'annonce
  const goToAnnouncementDetail = (id) => {
    navigate(`/announcement/${id}`)
  }
  const handleSearch = async () => {
    const queryParams = new URLSearchParams()
    try {

      searchValue?.clubName && queryParams.append('clubName', searchValue?.clubName)
      searchValue?.title && queryParams.append('title', searchValue?.title)
      await dispatch(searchAnnonces(queryParams?.toString()))

    } catch (error) {
      return (error)
    }
    setSearchValue({
      title: '',
      clubName: ''
    })
  }

  const handleSearchAgents = async () => {
    const queryParams = new URLSearchParams()
    try {

      searchValueAgents?.agentName && queryParams.append('agentName', searchValueAgents?.agentName)
      searchValueAgents?.title && queryParams.append('title', searchValueAgents?.title)
      await dispatch(searchAnnoncesAgents(queryParams?.toString()))

    } catch (error) {
      return (error)
    }
    setSearchValueAgents({
      title: '',
      agentName: ''
    })
  }
  const openModalForAnnouncment = (id) => {
    setAnouncmentId(id)
    setIsOpen(true)
  }

  const tabData = [
    {
      key: '1',
      title: 'Annonces des clubs',
      content: <>
        <div className="m-3 d-flex gap-2">
          <Input
            type="text"
            placeholder=" clubname"
            value={searchValue?.clubName}
            onChange={(e) => setSearchValue((prev) => ({
              ...prev,
              clubName: e.target.value
            })

            )}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />
          <Input
            type="text"
            placeholder="title"
            value={searchValue?.title}
            onChange={(e) => setSearchValue((prev) => ({
              ...prev,
              title: e.target.value
            })
            )}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />
          <Button
            onClick={() => handleSearch()}
          >
            🔍
          </Button>
          <Button onClick={() => dispatch(getAnounce())}
          >
            <ReloadOutlined />
          </Button>
        </div>

        {announces && announces?.length > 0 ? (
          <AnnouncesList
            announces={announces}
            forAgent={false}
            formatDate={formatDate}
            openModalForAnnouncment={openModalForAnnouncment}
          />
        ) : (
          <Row>
            <Col>
              <div className='text-center p-5'>
                <h4>Aucune annonce disponible</h4>
                <p>Les nouvelles annonces apparaîtront ici.</p>
              </div>
            </Col>
          </Row>
        )}</>,
    },
    {
      key: '2',
      title: 'Annonces des agents',
      content: <>
        <div className="m-3 d-flex gap-2">
          <Input
            type="text"
            placeholder=" agentName"
            value={searchValueAgents?.agentName}
            onChange={(e) => setSearchValueAgents((prev) => ({
              ...prev,
              agentName: e.target.value
            })

            )}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearchAgents();
              }
            }}
          />
          <Input
            type="text"
            placeholder="title"
            value={searchValueAgents?.title}
            onChange={(e) => setSearchValueAgents((prev) => ({
              ...prev,
              title: e.target.value
            })
            )}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearchAgents();
              }
            }}
          />
          <Button
            onClick={() => handleSearchAgents()}
          >
            🔍
          </Button>
          <Button onClick={() => dispatch(getAnounceAgents())}
          >
            <ReloadOutlined />
          </Button>
        </div>

        {announcesAgents && announcesAgents.length > 0 ? (
          <AnnouncesList
            announces={announcesAgents}
            forAgent={true}
            formatDate={formatDate}
            openModalForAnnouncment={openModalForAnnouncment}
          />
        ) : (
          <Row>
            <Col>
              <div className='text-center p-5'>
                <h4>Aucune annonce disponible</h4>
                <p>Les nouvelles annonces apparaîtront ici.</p>
              </div>
            </Col>
          </Row>
        )}</>,
    },
    {
      key: '3',
      title: 'Agents',
      content: <>
        {agents && agents.length > 0 ? (
          <AgentsList
            agents={agents}
            formatDate={formatDate}
          />
        ) : (
          <Row>
            <Col>
              <div className='text-center p-5'>
                <h4>Aucun agent disponible</h4>
              </div>
            </Col>
          </Row>
        )}
      </>,
    },
  ];

  // tri par « plus proche de maintenant » (avant ou après)
  const sortByProximity = (a, b) => {
    const now = dayjs();
    return Math.abs(dayjs(a?.startDate).diff(now))
      - Math.abs(dayjs(b?.startDate).diff(now));
  };
  console.log("isProfileComplete ::", isProfileComplete);

  return (
    <>

      {isProfileComplete === false && (
        <ModalInfo
          trigger={true}
          title="Profil incomplet"
          message={`${isProfileComplete} Votre profil est actuellement incomplet. Veuillez le compléter pour améliorer votre visibilité et permettre aux autres de mieux vous découvrir.`}
          showCancel={false}
        />
      )}

      {/* <Header /> */}

      {/* Section bannière + titre */}
      <HeroSection>
        <HeaderWrapper>
          <Header1 gapp="accueille" />
        </HeaderWrapper>
        <ImageWrapper>
          <ResponsiveImage src={banner} alt="Banner image" />
        </ImageWrapper>
      </HeroSection>

      {/* Section principale de contenu */}
      <ContentSection>
        <ApplicationModal
          isOpen={isOpen}
          toggle={() => setIsOpen(open => !open)}
          announcementId={anouncmentId}
        />

        <MainLayout>
          <Sidebar>
            {/* <div className='p-4' style={{ background: "#f6f6f6", borderRadius: "8px" }}>
              <h5>Événements à venir</h5>
              <p>Ne manquez pas ces événements !</p>
              {events?.map((ev, key) =>
              (
                <div key={key}>

                  <h3>{ev.title} {ev?.place && "à " + ev?.place}</h3>
                  <p>{ev?.startDate && "Date : " + ev.startDate?.slice(0, 10)}</p>
                  <p> {ev?.category && "Catégorie : " + ev?.category}</p>
                  <a href={ev.youtubeLink} >{ev.youtubeLink}</a>
                </div>

              ))
              }
            </div> */}
            <PaginatedList
              items={events}
              dateFilter={() => true}
              sortFn={sortByProximity}
            />

            <SubscriptionDetails />
          </Sidebar>

          <TabsWrapper>
            <TabsComponent tabs={tabData} />
          </TabsWrapper>
        </MainLayout>
      </ContentSection>
    </>
  );
}

// --- Styled Components ---

// Section de la bannière
const HeroSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background: #fff;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem; /* ESPACE entre sections */
  
  @media (min-width: 768px) {
    flex-direction: row;
    padding: 2rem;
  }
`;

const HeaderWrapper = styled.div`
  flex: 1;
  max-height: 400px;
`;

const ImageWrapper = styled.div`
  flex: 1.5;
  display: flex;
`;

const ResponsiveImage = styled.img`
  width: 100%;
  height: auto; /* Suppression de la contrainte de hauteur */
  object-fit: cover;
  border-radius: 0.25rem;
`;

// Section principale de contenu
const ContentSection = styled.section`
  margin-top: 1.5rem;
  padding: 1rem;
  background: #fff;
  border-radius: 0.5rem;

  @media (min-width: 768px) {
    padding: 2rem;
  }
`;

// Layout pour la sidebar et les onglets
const MainLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  justify-content:center;
  align-items: center;
  @media (min-width: 992px) {
    flex-direction: row-reverse;
    justify-content:center;
    align-items: flex-start;
  }
`;

// Sidebar des événements
const Sidebar = styled.aside`
  padding: 1rem;
  min-height: 400px;
  border-radius: 0.5rem;

  h5 {
    margin-bottom: 0.5rem;
  }

  p {
    margin-bottom: 1rem;
    font-size: 0.9rem;
  }

  /* Sticky activé pour écrans larges (≥ 992px) */
  @media (min-width: 992px) {
    position: sticky;
    top: 10px; /* Distance du haut de la page */
  }

  @media (max-width: 805px) {
    min-height: unset; 
    width: 90%;
    margin: 0 auto;
  }

  /* Écrans petits */
  @media (max-width: 991px) {
    min-height: unset;
    width: 75%;
    margin: 0 auto;
  }
      @media (max-width: 600px) {
    min-height: unset; 
    width: 95%;
    margin: 0 auto;
  }
`;


// Carte individuelle d’événement
const EventCard = styled.div`
  margin-bottom: 1rem;

  h3 {
    margin: 0.25rem 0;
    font-size: 1.1rem;
  }

  time {
    display: block;
    font-size: 0.85rem;
    color: #555;
  }

  a {
    word-break: break-all;
    font-size: 0.85rem;
    color: #0066cc;
  }
`;

// Wrapper pour le composant à onglets
const TabsWrapper = styled.div`
  flex: 1;
  width: 100%;
`;


export default Accueille